module.exports = "/images/vendor/vue-paycard/src/19.jpg?30e083fa664a3e9e92c4d9c13461f48f";